module.exports = __webpack_public_path__ + "right-arrow.fbff986476f53c62f90759f406fda00e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/right-arrow.svg
// module id = 160
// module chunks = 0